import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=fac2ff40&scoped=true"
import script from "./Appeals.vue?vue&type=script&lang=js"
export * from "./Appeals.vue?vue&type=script&lang=js"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=fac2ff40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac2ff40",
  null
  
)

export default component.exports